import { Spin } from "antd";
import has from "lodash/has";
import React from "react";
import Constant, { Tenant } from "./Constants";
import Functions, { getPerCapita } from "./Functions";
import MARKER_PERMISSIONS from "../../permissions/Markers.json";
import { havePermission } from "../../permissions";

const { getTenantName, getCensusNameMapping, FormateNumber, formatString } = Functions;

const { variables } = Constant;
const { clientShops, censusShops, filteredShops, bat_contracted_outlets, bat_contracted_outlets_selected } = variables;

const { EBM_REGIONAL, SUNTORY, UL_LDM, BAT_ORGANIZED, BAT_UK_INDEPENDENT, BAT_GERMANY, UL_INDONESIA } = Tenant;

const Components = {
	getCountTable: function getCountTable({ tenant, tableData }) {
		let newData = [
			havePermission(MARKER_PERMISSIONS.TABLE_CENSUS_SHOPS_COUNT) && `${getCensusNameMapping(tenant)}`,
			havePermission(MARKER_PERMISSIONS.TABLE_FILTERED_CENSUS_SHOPS_COUNT) && filteredShops,
			havePermission(MARKER_PERMISSIONS.TABLE_CLINET_SHOPS_COUNT) && clientShops
		].filter(Boolean);

		if (havePermission(MARKER_PERMISSIONS.TABLE_FILTERED_CLINET_SHOPS_COUNT)) {
			let Key = `${getTenantName(tenant)} Selected`;
			newData.push(Key);
			tableData = {
				...tableData,
				Key: tableData[Key]
			};
		}

		if (havePermission(MARKER_PERMISSIONS.TABLE_CLINET_1_SHOPS_COUNT)) {
			let Key = bat_contracted_outlets;
			newData.push(Key);
			tableData = {
				...tableData,
				Key: tableData[Key]
			};
		}

		if (havePermission(MARKER_PERMISSIONS.TABLE_FILTERED_CLINET_1_SHOPS_COUNT)) {
			let Key = bat_contracted_outlets_selected;
			newData.push(Key);
			tableData = {
				...tableData,
				Key: tableData[Key]
			};
		}

		newData = [...newData];

		if (tenant === UL_INDONESIA) {
			const key = "Covered %";
			const coveredPercentage = ((tableData[`${clientShops}`] / tableData.outlet_universe) * 100).toFixed(0);

			tableData = {
				...tableData,
				[key]: `${coveredPercentage}%`
			};
			newData = [...newData, "outlet_universe", key];
		}

		if (tenant === EBM_REGIONAL) {
			newData = [...newData, "cities", "village"];
		} else if (tenant === SUNTORY) {
			let KEY = "% Census against SPBT shops";
			newData = [...newData, KEY];
			tableData = {
				...tableData,
				[KEY]: `${((tableData[censusShops] / tableData[clientShops]) * 100).toFixed(0)}%`
			};
		} else if ([UL_LDM].includes(tenant)) {
			// shops_density
			// let KEY= "Shops Density";
			newData = [...newData, "cities", "village", "shops_density", "population_density", "area"];
		}

		if ([BAT_UK_INDEPENDENT].includes(tenant)) {
			newData = [...newData, "assigned", "unassigned"];
		}

		// per capita tenants
		if ([BAT_ORGANIZED, BAT_UK_INDEPENDENT, BAT_GERMANY].includes(tenant)) {
			const { census_per_capita, client_per_capita } = getPerCapita(tableData, tenant);
			tableData = { ...tableData, census_per_capita, client_per_capita };
			newData = [...newData, "census_per_capita", "client_per_capita"];
		}

		tableData = {
			...tableData,
			[`${getCensusNameMapping(tenant)}`]: tableData[censusShops]
		};
		const labelMapping = {
			client_shops: `${getTenantName(tenant)}`,
			census_per_capita: "Population / Census Shop",
			client_per_capita: `Population / BAT Shop`
		};
		let tableColumns = newData.map((key, index) => (
			<tr className={index % 2 === 0 && "main-tbl-bg"}>
				<th className="elipsisx">
					{`${key}`.startsWith("HoReCa") ? labelMapping[key] || key : formatString(labelMapping[key] || key)}
				</th>

				<th className="elipsisx">
					{has(tableData, key) && tableData[key] === "LOADING" ? (
						<Spin size="small" />
					) : (
						FormateNumber(tableData[key])
					)}
				</th>
			</tr>
		));

		return (
			<div style={{ width: "100%" }} className="cardshadow">
				<table className="table table-striped table-borderedX table-hover mb-0" style={{ width: "100%" }}>
					<tr className="bg-blue shadow">
						<th className="elipsisx">Stats</th>
						<th className="elipsisx "></th>
					</tr>
					{tableColumns}
				</table>
			</div>
		);
	}
};

export default Components;
